var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 26.056V12.078",
    stroke: "#5458F7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 34.056H8C5.79 34.056 4 32.266 4 30.056V12.056",
    stroke: "#5458F7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.978 8.05603H8.022C5.8 8.05603 4 9.85603 4 12.078C4 13.412 4.662 14.658 5.766 15.406L16.48 22.668C19.21 24.518 22.794 24.518 25.524 22.668L36.236 15.408C37.338 14.66 38 13.412 38 12.08V12.078C38 9.85603 36.2 8.05603 33.978 8.05603V8.05603Z",
    stroke: "#5458F7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.656 28.4C44.78 31.524 44.78 36.59 41.656 39.714C38.532 42.838 33.466 42.838 30.342 39.714C27.218 36.59 27.218 31.524 30.342 28.4C33.466 25.276 38.532 25.276 41.656 28.4Z",
    stroke: "#63C7C9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1099 32.5L35.2199 36.39L32.8879 34.056",
    stroke: "#63C7C9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerify);
export default __webpack_public_path__ + "static/media/email-verify.69ecd801.svg";
export { ForwardRef as ReactComponent };